module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-picker",
    class: _vm.$style.root
  }, [_c('dialog-drag', {
    staticClass: "dialog-1",
    attrs: {
      "options": {
        right: 0,
        buttonPin: false,
        buttonClose: false
      }
    }
  }, [_vm._t("dialog-top"), _c('chrome-picker', {
    ref: "colorPicker",
    class: {
      hidden: _vm.hideColorPicker
    },
    attrs: {
      "value": _vm.defaultColor
    },
    on: {
      "input": _vm.updateColors
    }
  }), _c('table', {
    staticClass: "color-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("slug")]), _c('th', [_vm._v("color")]), _c('th', [_vm._v("-text")]), _c('th', [_vm._v("-hover")]), _c('th', [_vm._v("-text-hover")]), _c('th')])]), _c('tbody', _vm._l((_vm.allColorKeys), function(key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._l((_vm.compiledTypes), function(name, typeKey) {
      return _c('td', {
        key: typeKey,
        class: [{
          overwritten: _vm.checkOverwrite(("" + key + name))
        }, "color"],
        style: (_vm.getKeyStyle(("" + key + name)))
      }, [_c('div', {
        staticClass: "color-block",
        on: {
          "click": function($event) {
            _vm.changeColor(("" + key + name), _vm.getCompiledColor(("" + key + name)), $event)
          }
        }
      }, [_vm._v(_vm._s(_vm.getCompiledColor(("" + key + name)))), _c('span', [_vm._v("*")])]), _c('button', {
        on: {
          "click": function($event) {
            _vm.resetKeyColor(("" + key + name), true)
          }
        }
      }, [_vm._v("x")])])
    }), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.resetKeyColor(key)
        }
      }
    }, [_vm._v("Reset")])])], 2)
  })), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "pt-3",
    attrs: {
      "colspan": "6"
    }
  }, [_c('input', {
    domProps: {
      "value": JSON.stringify(_vm.clientColors)
    }
  }), _c('button', {
    staticClass: "float-right",
    on: {
      "click": function($event) {
        _vm.resetKeyColor("all")
      }
    }
  }, [_vm._v("Reset All Colors")])])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44867c35"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/initializer/color-picker/ColorPicker.vue
// module id = 928
// module chunks = 1